import type { CellPositionType, CellsMapType, IdIndexMapType } from './index'

export const getNextCellByPosition = (cellsMap: CellsMapType, { row, column }: CellPositionType, key: string) => {
	const lastRowIndex = cellsMap.length - 1
	const lastColumnIndex = cellsMap[lastRowIndex].length - 1

	const nextStateByKey: Record<string, [number, number]> = {
		ArrowDown: [row + 1, column],
		ArrowUp: [row - 1, column],
		ArrowRight: [row, column + 1],
		ArrowLeft: [row, column - 1],
		Home: [0, 0],
		End: [lastRowIndex, lastColumnIndex],
	}

	const [nextRow, nextColumn] = nextStateByKey[key]

	return cellsMap[nextRow]?.[nextColumn]
}

export const getNextCell = (cellsMap: CellsMapType, idIndexMap: IdIndexMapType, id: string, key: string) =>
	getNextCellByPosition(cellsMap, idIndexMap[id], key)
